<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-11 11:20:59
 * @LastEditors: knx-xc
--> 
<template>
  <div class="login " :style="{height:height+'px'}">

    <div class="login-form">
      <div class="image"> <img src="../../assets/images/login/login_bg.png" alt=""></div>
      <div class="form">
        <div><img src="../../assets/images/logo.png" alt=""></div>
        <h1 v-text="'康乃馨官网后台登录'"></h1>
        <el-form :model="loginForm" class=" demo-form-inline" ref="loginForm" :rules="rules" size="large">
          <el-form-item prop="username">
            <el-input prefix-icon="el-icon-user-solid" clearable v-model="loginForm.username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" clearable placeholder="请输入密码" v-model="loginForm.password" show-password></el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-row :gutter="20" type="flex" justify="center">
              <el-col :span="12">
                <el-input prefix-icon="el-icon-postcard" placeholder="请输入验证码" v-model="loginForm.captcha" @keyup.enter.native="onSubmit" clearable></el-input>
              </el-col>
              <el-col :span="12" class="login-captcha">
                <img :src="captchaPath || defaultCaptcha" @click="getCaptcha" alt="">
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">登录</el-button>
          </el-form-item>
        </el-form>
      </div>

      <img class="icon" src="../../assets/images/login/login_icon.png" alt="">
      <div class="floor1"></div>
      <div class="floor2"></div>

    </div>

  </div>
</template>
 
<script>
import { getUUID } from '../../tools/index'
import { getCaptchaPath, login } from '../../request/api.admin/common'
export default {
  name: '',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        uuid: ''
      },
      defaultCaptcha: require('../../assets/images/logo.png'),
      captchaPath: '',
      rules: {
        username: [
          { required: true, message: '帐号不能为空', trigger: 'blur' },
          { required: true, message: '帐号不能为空', trigger: 'change' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { required: true, message: '密码不能为空', trigger: 'change' },
        ],
        captcha: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
          { required: true, message: '验证码不能为空', trigger: 'change' },
        ]
      },
    }
  },
  created() {
    this.getCaptcha();
  },
  computed: {
    height() {
      return (document.documentElement.clientHeight || document.body.clientHeight)
    }
  },
  mounted() {

  },
  methods: {
    onSubmit() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          login(this.loginForm).then(data => {
            // console.log(data)
            if (data.code === 0) {
              // this.$message.success('登录成功')
              this.$message({
                message:'登录成功',
                type:'success',
                offset:300,
              })
              // this.$cookie.set('token', data.token, data.expire)
              this.$cookie.set('token', data.token)
              this.$router.replace({ path: '/admin' })
            } else {
              this.getCaptcha();

            }
          })
        }
      })
    },
    // 获取验证码
    getCaptcha() {
      this.loginForm.uuid = getUUID();
      this.captchaPath = `${this.$url}/captcha.jpg?uuid=${this.loginForm.uuid}`;
    },
  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
// * {
//   outline: 1px solid red;
// }
.login {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    90deg,
    rgba(28, 168, 212, 1) 0%,
    rgba(34, 129, 201, 1) 100%
  );
}

.login-form {
  // width: 1200px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
  box-shadow: 0px 6px 12px rgba(28, 132, 212, 1);
  border-radius: 10px;
  position: relative;
  z-index: 5;
  .image {
    width: 300px;
    height: 100%;
    position: relative;
    z-index: 5;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .form {
    position: relative;
    z-index: 5;
    background: #ffffff;
    padding: 20px 60px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    h1 {
      margin: 32px 0;
      font-size: 40px;
      font-weight: bold;
      line-height: 32px;
      color: #124990;
    }
    /deep/ .el-button {
      width: 100%;
      background: #1c84d4;
      padding: 0px;
      border-radius: 6px;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
    }
    /deep/ .el-input__inner {
      width: 100%;
      border-radius: 6px;
      font-size: 16px;
      // height: 50px;
      // line-height: 50px;
    }
    //
    .login-captcha {
      height: 40px;
      img {
        width: 160px;
        height: 100%;
      }
    }
  }
  img.icon {
    position: absolute;
    top: -100px;
    left: -110px;
    z-index: 6;
  }
  .floor1 {
    position: absolute;
    bottom: -25px;
    left: 30px;
    right: 30px;
    height: 100px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 12px rgba(28, 132, 212, 1);
    opacity: 0.5;
    border-radius: 10px;
    z-index: 4;
  }
  .floor2 {
    position: absolute;
    bottom: -45px;
    left: 56px;
    right: 56px;
    height: 100px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 12px rgba(28, 132, 212, 1);
    opacity: 0.2;
    border-radius: 10px;
    z-index: 3;
  }
}
</style>